import clsx from "clsx";

const SEGMENT_STYLES: Record<string, { bg: string; fg: string; emoji: string }> = {
  Campeones: { bg: "bg-brand-500", fg: "text-white", emoji: "★" },
  "Clientes leales": { bg: "bg-brand-100", fg: "text-brand-700", emoji: "♥" },
  "Promesa potencial": { bg: "bg-info/10", fg: "text-info", emoji: "→" },
  "Nuevo cliente": { bg: "bg-info/20", fg: "text-info", emoji: "✦" },
  "Necesitan atención": { bg: "bg-warning/10", fg: "text-warning", emoji: "!" },
  "En riesgo de perder": { bg: "bg-warning/20", fg: "text-warning", emoji: "▲" },
  "A punto de dormirse": { bg: "bg-ink-200", fg: "text-ink-700", emoji: "z" },
  "No puedo perderlos": { bg: "bg-danger/10", fg: "text-danger", emoji: "!!" },
  "Hibernando valiosos": { bg: "bg-ink-100", fg: "text-ink-600", emoji: "❄" },
  "En riesgo de churn": { bg: "bg-danger/20", fg: "text-danger", emoji: "↓" },
  Perdidos: { bg: "bg-ink-100", fg: "text-ink-500", emoji: "·" },
};

interface Props {
  label?: string;
  rfm?: string;
  size?: "sm" | "md";
  className?: string;
}

export function RfmBadge({ label, rfm, size = "sm", className }: Props) {
  if (!label) return <span className="text-ink-400 text-xs">Sin segmentar</span>;
  const style = SEGMENT_STYLES[label] ?? { bg: "bg-ink-200", fg: "text-ink-700", emoji: "?" };
  const padding = size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm";
  return (
    <span
      className={clsx(
        "inline-flex items-center gap-1 rounded-full font-medium",
        style.bg, style.fg, padding, className,
      )}
      title={rfm ? `RFM ${rfm}` : undefined}
    >
      <span className="font-bold">{style.emoji}</span>
      {label}
    </span>
  );
}
